import e from "react";
import { translate as t, hasTranslation as r } from "@aws-amplify/ui";
import { Button as o } from "../../../primitives/Button/Button.js";
import { Flex as i } from "../../../primitives/Flex/Flex.js";
import { View as n } from "../../../primitives/View/View.js";
import { VisuallyHidden as m } from "../../../primitives/VisuallyHidden/VisuallyHidden.js";
import { FederatedSignIn as a } from "../FederatedSignIn/FederatedSignIn.js";
import { useAuthenticator as l } from "@aws-amplify/ui-react-core";
import { useCustomComponents as s } from "../hooks/useCustomComponents/index.js";
import { useFormHandlers as d } from "../hooks/useFormHandlers/useFormHandlers.js";
import { RemoteErrorMessage as u } from "../shared/RemoteErrorMessage.js";
import { FormFields as p } from "../shared/FormFields.js";
function c() {
  const {
      isPending: r
    } = l(e => [e.isPending]),
    {
      handleChange: f,
      handleSubmit: g
    } = d(),
    {
      components: {
        SignIn: {
          Header: E = c.Header,
          Footer: F = c.Footer
        }
      }
    } = s();
  return e.createElement(n, null, e.createElement(E, null), e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-signin": "",
    method: "post",
    onSubmit: g,
    onChange: f
  }, e.createElement(a, null), e.createElement(i, {
    direction: "column"
  }, e.createElement(i, {
    as: "fieldset",
    direction: "column",
    isDisabled: r
  }, e.createElement(m, null, e.createElement("legend", null, t("Sign in"))), e.createElement(p, null)), e.createElement(u, null), e.createElement(o, {
    isDisabled: r,
    isFullWidth: !0,
    type: "submit",
    variation: "primary",
    isLoading: r,
    loadingText: t("Signing in")
  }, t("Sign in")))), e.createElement(F, null));
}
c.Footer = () => {
  const {
      toResetPassword: i
    } = l(e => [e.toResetPassword]),
    m = r("Forgot your password? ") ? t("Forgot your password? ") : t("Forgot your password?");
  return e.createElement(n, {
    "data-amplify-footer": ""
  }, e.createElement(o, {
    fontWeight: "normal",
    onClick: i,
    size: "small",
    variation: "link"
  }, m));
}, c.Header = function () {
  return null;
};
export { c as SignIn };